export enum UserType {
  ADMIN = 'admin',
  ONWER = 'onwer',
  OWNER = 'owner',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}
